import PageHeader from 'components/common/general/layouts/PageHeader';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import React, { useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { CloseDealPageStore, CloseDealPageStoreContext, useCloseDealPageStore } from 'store/pages/close-deal/pageStore';
import { observer } from 'mobx-react-lite';
import { PageContentStyled, PageWrapperStyled } from './styles';

const PageContent: React.FC = observer(() => {
  const history = useHistory();
  const { periodId } = useParams<{ periodId: string }>();

  const { closeDeal, isLoading, completeStepUrl, loadInitialData } = useCloseDealPageStore();

  useEffect(() => {
    void loadInitialData(periodId);
  }, []);

  async function onCloseDeal(): Promise<void> {
    await closeDeal();
    if (completeStepUrl) {
      history.push(completeStepUrl);
    }
  }

  return (
    <PageContentStyled>
      <OverlaySpinner display={isLoading} size="5rem" />
      <Button color="primary" size="large" width="25rem" onClick={onCloseDeal}>
        Close Deal
      </Button>
    </PageContentStyled>
  );
});

export const CloseDealPage: React.FC = () => {
  const history = useHistory();
  const { periodId } = useParams<{ periodId: string }>();

  function returnBack(): void {
    history.push(`/post-submit-checklist/${periodId}`);
  }

  const pageStore = useMemo(() => new CloseDealPageStore(), []);
  return (
    <CloseDealPageStoreContext.Provider value={pageStore}>
      <ProposalStatusLayout>
        <PageWrapperStyled>
          <PageHeader title="Close Deal" subtitle="This page is currently under development." onRedirect={returnBack} />
          <PageContent />
        </PageWrapperStyled>
      </ProposalStatusLayout>
    </CloseDealPageStoreContext.Provider>
  );
};
